import axios from './../../axios'

export default {
  setAuthUser(state, authUser) {
    state.authUser = authUser
  },
  setAuthToken(state, authToken) {
    if (authToken) {
      state.authExpiry = Date.now() + 3600
      state.authToken = authToken
      axios.defaults.headers.Authorization = 'Bearer ' + state.authToken
    } else {
      state.authToken = null
      state.authExpiry = Date.now()
      delete axios.defaults.headers.Authorization
    }
  },
  setUser(state, user) {
    state.user = user
    user.GroupIds = user.GroupIds || []
  },
  setBrandingPartner(state, brandingPartner) {
    state.brandingPartner = brandingPartner
  },
  setUserGroups(state, currentUserGroups) {
    state.currentUserGroups = currentUserGroups
  },
  setProviderUser(state, providerUser) {
    state.isProviderUser = providerUser
  },
  setUserName(state, { firstName, lastName }) {
    state.user.firstName = firstName
    state.user.lastName = lastName
  },
  setUserSignature(state, data) {
    state.signature = data
  },
  setActiveCommunity(state, community) {
    state.activeCommunity = community
  },
  setEmail(state, email) {
    state.email = email
  },
  setError(state, error) {
    state.error = error
  },
  setSuccess(state, success) {
    state.success = success
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js